const types = {
    SAVE_EVALUATE_PARAMS: 'evaluate/SAVE_EVALUATE_PARAMS',
};

export const saveEvaluateParams = params => ({
    type: types.SAVE_EVALUATE_PARAMS,
    params,
});

const initState = {
    evaluateParams: {},
};

const clinicalEvaluationReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_EVALUATE_PARAMS:
            return {
                ...state,
                evaluateParams: {
                    ...state.evaluateParams,
                    ...actions.params,
                },
            };
        default:
            return state;
    }
}

export default clinicalEvaluationReducer;


// WEBPACK FOOTER //
// ./src/actions/clinicalEvaluationActions.js